import React, { useState, useEffect, useRef } from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap'
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import { post, config } from '../../axios';
import { formatTime } from '../../utils/index'
import { scoreType, roomTypeMap } from '../../axios/dictionaries'
import Detail from './components/CustomerDetail'

const params = { keyword: '', channelId: 0, pageSize: 10 }

const Channel = () => {
    const [loading, setLoading] = useState(false)
    const [queryData, setQueryData] = useState(() => params)
    const [current, setCurrent] = useState(1)
    const [tableTotal, setTableTotal] = useState(1)
    const [tableData, setTableData] = useState([])
    const [channeList, setChanneList] = useState([])
    const detailRef = useRef(null)

    useEffect(() => {
        handleSearch()
        postFindList()
    }, [])

    const searchFormItem = [
        {
            tagName: 'Input',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
            title: '在名称跟token查询模糊查询'
        },
        {
            tagName: 'Select',
            formConfig: { name: 'channelId' },
            attribute: { placeholder: '请选择渠道', style: { width: '160px' } },
            optionData: channeList
        },
        {
            tagName: 'Select',
            formConfig: { name: 'roomType' },
            attribute: { placeholder: '请选择房源类型', style: { width: '160px' } },
            optionData: roomTypeMap
        },
        {
            tagName: 'Select',
            formConfig: { name: 'scoreType' },
            attribute: { placeholder: '请选择评分区间', style: { width: '160px' } },
            optionData: scoreType
        },
    ]

    const columns = [
        { title: '客户名称', dataIndex: 'name' },
        { title: '客户手机', dataIndex: 'phone' },
        {
          title: '房源类型', dataIndex: 'roomType',
          render(text) {
            const current = roomTypeMap.find(item => item.value == text)
            if (!current) return '-'
            return current.title
          }
        },
        { title: '公寓名称', dataIndex: 'apartmentName' },
        { title: '公寓地址', dataIndex: 'apartmentAddress' },
        { title: '渠道名称', dataIndex: 'channelName' },
        { title: '评估分数', dataIndex: 'score' },
        { title: '评估金额', dataIndex: 'assessAmount' },
        {
            title: '创建时间', dataIndex: 'createTime',
            render(text) {
                if (!text) return '-'
                return formatTime(text)
            }
        },
        {
          title: '操作', dataIndex: 'id',
          render(text) {
            return (
              <span className="showClickDetail" onClick={() => { handleDetail(text) }} >详情</span>
            )
          }
        }
    ]

    const handleSearch = (values = {}) => { //表单搜索/分页

        let data = {};
        if (values.current) {
            data = Object.assign(queryData, values);
        } else {
            data = Object.assign({}, queryData, values, { current });
        }
        setQueryData(Object.assign({}, queryData, values))
        setLoading(true)
        post({
            url: config.API_channelCustomer_findPage,
            data,
        }).then(res => {
            let records = res.records;
            records.map(item => item.updateTime = formatTime(item.updateTime))
            const { current, total } = res
            setCurrent(current)
            setTableTotal(total)
            setTableData(records)
            setLoading(false)
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            setLoading(false)
        });
    }

    const handleDetail = (id) => {
      post({
        url: config.API_channelCustomer_getById,
        data: { id }
      }).then(res => {
        detailRef.current.onShow(res)
      }).catch(() => {
        message.error('详情获取失败!')
      })
    }

    const postFindList = () => {
        post({
            url: config.API_channel_findList
        }).then(res => {
            setChanneList(res.map(item => ({ title: item.name, value: item.id })))
        }).catch(err => {
            message.error(err.message || '获取客户下拉');
        });
    }

    return (
        <PageWrap
            loading={loading}
        >
            <div className="search-wrapper">
                <SuperForm
                    data={searchFormItem}
                    sumbit={handleSearch}
                    addParams={'current'}
                    // showCancel={false}
                />
            </div>

            <TableDOM
                columns={columns}
                data={tableData}
                total={tableTotal}
                current={current}
                onChange={handleSearch}
            />

            <Detail wrappedComponentRef={detailRef} />
        </PageWrap>
    )
}

export default Channel


// WEBPACK FOOTER //
// ./src/page/Employee/ChannelCustomer.jsx